
import { mapGetters } from 'vuex'
import RedDot from '~/components/Header/RedDot/index.vue'

export default {
  components: { RedDot },
  computed: {
    ...mapGetters({
      practiceLocation: 'user/practiceLocation'
    }),
    showRedDot() {
      return this.practiceLocation?.hasOrderIssues || this.practiceLocation?.hasNewReturnLabels
    }
  }
}
